import enUS from './en-US';
import uk from './uk';

export default {
  'en-US': enUS,
  uk,
};
